// Mock data for Nova-Stron Construction Website

export const companyInfo = {
  name: "Nova-Stron",
  tagline: "Budujemo vašu budućnost na čvrstim temeljima",
  description: "Kvaliteta gradnje provjerena vremenom",
  stats: {
    experience: "5+",
    experienceLabel: "Godina iskustva",
    projects: "12",
    projectsLabel: "Završenih projekata",
    quality: "100%",
    qualityLabel: "Jamstvo kvalitete"
  }
};

export const navigation = [
  { name: "Početna", href: "#home" },
  { name: "Usluge", href: "#services" },
  { name: "O nama", href: "#about" },
  { name: "Projekti", href: "#projects" },
  { name: "Kontakt", href: "#contact" }
];

export const services = [
  {
    id: 1,
    icon: "Building2",
    title: "Betonske konstrukcije",
    description: "Izvodimo betonske konstrukcije svih razina složenosti — od privatnih vila do velikih višekatnih i komercijalnih objekata. Naš rad temelji se na dugogodišnjem iskustvu, suvremenim tehnologijama i strogoj kontroli kvalitete u svakoj fazi gradnje.",
  },
  {
    id: 2,
    icon: "BrickWall",
    title: "Zidarski radovi",
    description: "Precizni zidarski radovi za sve vrste objekata — od nosivih zidova do pregradnih konstrukcija. Koristimo kvalitetne materijale i provjerene tehnike kako bismo osigurali trajnost i besprijekornu izvedbu.",
  },
  {
    id: 3,
    icon: "Hammer",
    title: "Rekonstrukcija",
    description: "Rekonstrukcija i obnova postojećih objekata uz očuvanje njihove funkcionalnosti i sigurnosti. Modernim metodama produljujemo vijek trajanja vaših građevina.",
  },
  {
    id: 4,
    icon: "Droplets",
    title: "Hidroizolacijski radovi",
    description: "Pouzdana hidroizolacija temelja, krovova, terasa i podrumskih prostora. Štitimo vaše objekte od vlage i prodora vode koristeći suvremene hidroizolacijske sustave.",
  }
];

export const whyChooseUs = {
  title: "Pouzdanost Izvrsnost",
  subtitle: "ZAŠTO ODABRATI NAS",
  description: "Nova-Stron je građevinska tvrtka iz Makarske specijalizirana za izvođenje betonskih konstrukcija. Stvaramo vrhunska građevinska rješenja koja ne samo da ispunjavaju, već i nadmašuju očekivanja klijenata. Naš tim profesionalaca jamči preciznost, sigurnost i besprijekornu izvedbu svakog projekta.",
  mission: "Naša misija",
  missionText: "Gradimo čvrste temelje budućnosti, spajajući inovativne tehnologije, vrhunsku stručnost i beskompromisnu posvećenost kvaliteti i potrebama klijenata.",
  values: [
    "Beskompromisna kvaliteta",
    "Preciznost u rokovima",
    "Stručni pristup",
    "Kontinuirano unapređenje"
  ]
};

export const projects = [
  {
    id: 1,
    title: "Stambena zgrada Makarska",
    category: "Betonske konstrukcije",
    image: "/projects/p1-5.webp",
    images: [
      "/projects/p1-5.webp",
      "/projects/p1-aerial.webp",
      "/projects/p1-building.webp",
      "/projects/p1-3.webp",
      "/projects/p1-6.webp",
      "/projects/p1-7.webp",
      "/projects/p1-8.webp"
    ],
    description: "Stambena zgrada u Makarskoj, površine 800 m², sastoji se od 4 kata i ima 6 apartmana."
  },
  {
    id: 2,
    title: "Hotelsko-rekreacijski kompleks Bjelovar",
    category: "Betonske konstrukcije",
    image: "https://customer-assets.emergentagent.com/job_8cea87bd-61e9-4087-b4b8-94258a5847b3/artifacts/czmzd2oi_IMG_3686%20%281%29.webp",
    images: [
      "https://customer-assets.emergentagent.com/job_8cea87bd-61e9-4087-b4b8-94258a5847b3/artifacts/czmzd2oi_IMG_3686%20%281%29.webp",
      "https://customer-assets.emergentagent.com/job_8cea87bd-61e9-4087-b4b8-94258a5847b3/artifacts/khtuyx6p_IMG_3307%20%281%29.webp",
      "https://customer-assets.emergentagent.com/job_8cea87bd-61e9-4087-b4b8-94258a5847b3/artifacts/jnenwawy_IMG_3691%20%281%29.webp",
      "/projects/p2-3.webp"
    ],
    description: "Hotelsko-rekreacijski kompleks u Bjelovaru, površine 1200 m², obuhvaća glavnu hotelsku zgradu, teretanu, dva bazena (dječji i sportski) te tri sportska terena, od kojih su dva namijenjena za padel tenis."
  },
  {
    id: 3,
    title: "Stambena zgrada Tučepi",
    category: "Betonske konstrukcije",
    image: "https://customer-assets.emergentagent.com/job_8cea87bd-61e9-4087-b4b8-94258a5847b3/artifacts/fjweo078_IMG_3248.JPG",
    images: [
      "https://customer-assets.emergentagent.com/job_8cea87bd-61e9-4087-b4b8-94258a5847b3/artifacts/fjweo078_IMG_3248.JPG",
      "/projects/p3-1.webp",
      "/projects/p3-2.webp",
      "/projects/p3-3.webp",
      "/projects/p3-4.webp"
    ],
    description: "Stambena zgrada u Tučepima, površine 800 m², sastoji se od 4 kata i ima 6 apartmana."
  },
  {
    id: 4,
    title: "Osnovna škola Virovitica",
    category: "Betonske konstrukcije",
    image: "/projects/p4-1.webp",
    images: [
      "/projects/p4-1.webp",
      "/projects/p4-2.webp",
      "/projects/p4-3.webp",
      "/projects/p4-4.webp"
    ],
    description: "Izgradnja moderne škole u Virovitici, Hrvatska. Ukupni volumen ugrađenog betona iznosi oko 6.000 m³, a zgrada se sastoji od dvije etaže."
  }
];

export const contactInfo = {
  title: "Kontaktirajte nas",
  subtitle: "STUPITE U KONTAKT",
  description: "Imate projekt u planu? Kontaktirajte nas za besplatnu procjenu i savjetovanje.",
  phone: {
    label: "Telefon",
    value: "+385 91 5256 937",
    icon: "Phone"
  },
  email: {
    label: "Email",
    value: "info@nova-stron.eu",
    icon: "Mail"
  },
  address: {
    label: "Ured 28A",
    value: "Nova-Stron d.o.o., Ul. Ante Starčevića 32, 21300, Makarska",
    icon: "MapPin"
  },
  oib: {
    label: "OIB",
    value: "46134576445",
    icon: "FileText"
  }
};

export const footer = {
  description: "Vodeća tvrtka za betonske radove u Hrvatskoj. Gradimo s pouzdanošću, precizno i na vrijeme.",
  quickLinks: [
    { name: "Početna", href: "#home" },
    { name: "O nama", href: "#about" },
    { name: "Projekti", href: "#projects" },
    { name: "Kontakt", href: "#contact" }
  ],
  services: [
    "Betonske konstrukcije",
    "Zidarski radovi",
    "Rekonstrukcija",
    "Hidroizolacijski radovi"
  ],
  contact: {
    phone: "+385 91 5256 937",
    email: "info@nova-stron.eu",
    website: "nova-stron.eu"
  },
  copyright: "© 2025 Nova-Stron."
};
